// extracted by mini-css-extract-plugin
module.exports = {"reference":"Reference_reference__1c8Zq","text_section":"Reference_text_section__21Ncy","gallery":"Reference_gallery__38eE3"};